// Matches `/blog/<slug>` (exactly two path segments, first `blog`).
// `/blog/rss.xml` never reaches here — it's an Express route mounted before the
// SSR catch-all. `precedence: 100` wins over the CMS catch-all Route Function.
export function route(pageContext: { urlPathname: string }) {
  const segments = pageContext.urlPathname.split("/").filter(Boolean);
  if (segments.length === 2 && segments[0] === "blog") {
    return { routeParams: { slug: segments[1] }, precedence: 100 };
  }
  return false;
}
